import { useQuery, useMutation } from "@tanstack/react-query";
import { UpdateHelpRequest, HelpOrderingField } from "../types/api/help";
import {
  fetchHelps,
  createHelp,
  updateHelp,
  deleteHelps,
} from "../services/help";

export const useHelpQuery = (
  page: number,
  limit: number,
  ordering?: HelpOrderingField,
  search?: string,
  topic_id?: string,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["help-list", page, limit, ordering, search, topic_id],
    queryFn: () =>
      fetchHelps({
        limit,
        offset: (page - 1) * limit,
        ordering,
        search,
        topic_id,
      }),
    retry: 0,
    enabled: options?.enabled ?? true,
  });
};

export const useCreateHelpMutation = () => {
  return useMutation({
    mutationFn: createHelp,
  });
};

export const useUpdateHelpMutation = () => {
  return useMutation({
    mutationFn: ({ faqId, data }: { faqId: string; data: UpdateHelpRequest }) =>
      updateHelp(faqId, data),
  });
};

export const useDeleteHelpMutation = () => {
  return useMutation({
    mutationFn: deleteHelps,
  });
};
